import { Component, ViewChildren, QueryList, OnInit, Optional, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../shared/base-components/base.component';
import { NotificationService } from '../services/notification.service';

// Programmer Notes for Bug# 36340, item #7
// The state of the selected boxes is externalized
// The state of the selected boxes is shipped out and stored externally
// These are then shipped back into the component as arguments in the form of TeamSelectionData
// The incoming data is available in the context object.
// Also, note:  Any changes made to check box state has to be synchronized across this.teamList, this.selectedTeams
// The value being synchronized is the object's [selected] property for this.teamList
// and the object's "id" value for this.selectedTeams
// It was also observed that somehow "ngAfterViewInit" was being called even before the template DOM elements were fully created
// This created certain challenges.

export class TeamSelectionData {
    constructor(public teamIdCollxn: any[]) {}
}

@Component({
    selector: 'team-selection-modal',
    templateUrl: './team-selection.html'
})
export class TeamSelectionWindow extends BaseComponent implements OnInit {
    public teamList: any;
    private selectedTeams: number[] = new Array();
    @ViewChildren('teamMember') teamMembers: QueryList<any>;

    constructor(
        public dialogRef: MatDialogRef<TeamSelectionWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TeamSelectionData,
        private notificationService: NotificationService
    ) {
        super();

        this.notificationService.getAvailableTeams().subscribe(result => {
            this.teamList = result.result;
            this.initializeState();
        });
    }

    ngOnInit() {
        console.log(this.data.teamIdCollxn);
    }

    public initializeState(): void {
        let matchFound = false;
        this.teamList.forEach(teamId => {
            this.data.teamIdCollxn.forEach(rawTeamId => {
                if (teamId['id'] == rawTeamId['id']) {
                    matchFound = true;
                }
            });
            if (matchFound) {
                teamId['selected'] = true;
                this.selectedTeams.push(teamId['id'].valueOf());
            } else {
                teamId['selected'] = false;
            }
            matchFound = false;
        });
    }

    public cancel() {
        this.dialogRef.close();
    }

    public selectionMade($event) {

        var selectedValue = +$event.target.value;

        const index = this.selectedTeams.indexOf(selectedValue);

        if ($event.target['checked']) {
            if (index === -1) {
                this.selectedTeams.push(selectedValue);
            }
        } else { // Deselected
            if (index !== -1) {
                this.selectedTeams.splice(index, 1);

                // sync changes on teamList
                var deselectThis = this.teamList.filter(item => item['id'] == selectedValue);
                if (deselectThis) {
                    deselectThis[0]['selected'] = false;
                }
            }
        }
    }

    public done() {
        this.teamList.forEach(team => {
            if (team['selected'] == true ) {
                this.selectedTeams.push(team['id'].valueOf());
            }
        });
        var result = this.teamList.filter(x => this.selectedTeams.indexOf(x.id) !== -1);
        this.dialogRef.close(result);
    }
}
